import { COUPON_ROUTES as couponRoutes } from '~/api/routes' 

export const state = () => ({
  coupons: [],
  pagination: {},
  isRequesting: false,
  hasError: false,
});

export const getters = {
  allCoupons: (state) => state.coupons,
};

export const mutations = {
  
  COUPONS_LOAD(state) {
    state.hasError = false;
    state.isRequesting = true;
  },
  
  COUPONS_SUCCESS(state, payload) {
    state.coupons = payload;
    state.hasError = false;
  },
  
  COUPONS_ERROR(state) {
    state.coupons = [];
    state.hasError = true;
  },
  
  COUPONS_LOADED(state) {
    state.isRequesting = false;
  },

  
  COUPONS_PAGINATION(state, pagination) {
    
    state.pagination = pagination;
  },

  
  REMOVE_COUPON(state, couponId) {
    state.coupons = state.coupons.filter((c) => c.id !== couponId);
  },
  ADD_COUPON(state, coupon) {
    state.coupons.unshift(coupon);
  },
  UPDATE_COUPON(state, updatedCoupon) {
    const index = state.coupons.findIndex(c => c.id === updatedCoupon.id);
    if (index !== -1) {
      
      state.coupons.splice(index, 1, updatedCoupon);
    }
  },
};

export const actions = {
  /**
   *  Get list of coupons
   *  @param {Object} params - filter or pagination params
   */
  async getCoupons({ commit }, params = {}) {
    commit('COUPONS_LOAD');
    try {
      const queryUrl = { ...couponRoutes.list };
      
      

      const response = await this.$api.request(queryUrl, {}, params);
      
      commit('COUPONS_SUCCESS', response.payload || []);
      
      

    } catch (error) {
      commit('COUPONS_ERROR');
    } finally {
      commit('COUPONS_LOADED');
    }
  },

  /**
   *  Create a new coupon
   */
  async createCoupon({ commit, dispatch }, couponData) {
    commit('COUPONS_LOAD');
    try {
      const response = await this.$api.request(couponRoutes.create, {}, couponData);
      
      commit('ADD_COUPON', response.payload);
  
    } catch (error) {
      commit('COUPONS_ERROR');
    } finally {
      commit('COUPONS_LOADED');
    }
  }
  ,

  /**
   *  Update a coupon
   */
  async updateCoupon({ commit }, couponData) {
    commit('COUPONS_LOAD');
    try {
      const response = await this.$api.request(
        couponRoutes.update,
        { id: couponData.id },
        couponData
      );
      commit('UPDATE_COUPON', response.payload);
    } catch (error) {
      commit('COUPONS_ERROR');
    } finally {
      commit('COUPONS_LOADED');
    }
  },

  /**
   *  Delete a coupon
   */
  async deleteCoupon({ commit }, couponId) {
    commit('COUPONS_LOAD');
    try {
      await this.$api.request(couponRoutes.delete, { id: couponId });
      commit('REMOVE_COUPON', couponId);
    } catch (error) {
      commit('COUPONS_ERROR');
    } finally {
      commit('COUPONS_LOADED');
    }
  },
};
